import { createSelector } from 'reselect';
import OriginImpcOperatorPredesSenderMismatchSummaryColumns from '../../containers/OriginImpcOperatorPredesSenderMismatchSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';


export const getGeneratedOnDateTime =
  state => state.reporting.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, OriginImpcOperatorPredesSenderMismatchSummaryColumns);
